import {
  post_request
} from '../axiosFun'

//待处理故障工单列表
export const get_faultoder_list = (params) => {
  params = {
    row: {
      vin: params.vin,
      description: params.description,
      submitter: params.submitter,
      submit_day: params.submit_day,
      page_no: params.page,
      page_size: params.limit
    }
  }
  return post_request("/web/fault-repair-order/list", params)
}
//已处理故障工单列表
export const get_history_order = (params) => {
  params = {
    row: {
      vin: params.vin,
      description: params.description,
      submitter: params.submitter,
      submit_day: params.submit_day,
      page_no: params.page,
      page_size: params.limit
    }
  }
  return post_request("/web/fault-repair-order/history_order", params)
}
//转接人列表
export const get_faultoder_get_users = (params) => {
  params = {
    row: {
    }
  }
  return post_request("/web/fault-repair-order/get_users", params)
}
//修改
export const get_faultoder_edit = (params) => {
  params = {
    row: {
      id:params.id,
      user_id: params.user_id,
      description: params.description,
    }
  }
  return post_request("/web/fault-repair-order/submit", params)
}
//更改状态
export const get_faultoder_switch_status = (params) => {
  params = {
    row: {
      id: params.id,
      status:2,
      opinion: params.opinion
    }
  }
  return post_request("/web/fault-repair-order/handle", params)
}
//获取车辆定位
export const get_lng_lat = (params) => {
  params = {
    row: {
      id:params,
    }
  }
  return post_request("/web/fault-repair-order/get_lng_lat", params)
}



// WEBPACK FOOTER //
// ./src/api/operation/faultoder.js